import type { BookLanguageRow } from '../../Settings/lists/singleTableListSupport';
import { BOOK_LANGUAGE_FORM_EN_ID } from '../../Settings/lists/bookLanguageFormSupport';
import { areBookPagesStepComplete } from './bookFormPagesMandatory';
import type { BookFormDraft } from './types';

/**
 * Per-step completion for the stepper checkmarks. Matches mandatory fields enforced on save
 * (see validateBookFormDraft). Descriptions are optional so step 4 follows step 3 (гарчиг).
 */
export function computeBookFormStepCompletion(
  draft: BookFormDraft,
  displayBookLanguages?: BookLanguageRow[],
): boolean[] {
  const anyLang = Object.entries(draft.language_enabled).some(([, v]) => v);

  const step0 = anyLang;

  const step1 =
    Boolean(draft.author_id.trim()) &&
    draft.category_ids.length > 0 &&
    draft.age_group_ids.length > 0;

  const coverOk = Boolean(draft.cover_image_path.trim() || draft.cover_image_file);
  const step2 = anyLang && coverOk;

  const enOn = Boolean(draft.language_enabled[BOOK_LANGUAGE_FORM_EN_ID]);
  const enTitleOk =
    !enOn || (draft.name_map[BOOK_LANGUAGE_FORM_EN_ID] ?? '').trim().length > 0;
  const step3 = step2 && enTitleOk;

  const step4 = step3;

  const step5 = step4 && areBookPagesStepComplete(draft, displayBookLanguages);

  return [step0, step1, step2, step3, step4, step5];
}
